import {capitalizeFirstLetter} from '~/common/utils';
import {Typography} from '~library/atoms/Typography';
import {ClickOutLineIcon} from '~library/svg/ClickOutLineIcon';
import {GiftlistImage} from './GiftlistImage';
import {getGiftlistType} from './utils';
import './GuestGiftlist.sass';

export const GuestGiftlist = () => {
  const giftlistType = capitalizeFirstLetter(getGiftlistType());
  const {isMobile} = evite.detects;
  const url = window.evite_event.gift_list_url;
  const hostName = window.evite_event.host_name;
  if (!url) return;

  const GuestHeading = () => (
    <Typography variant="header3" color="pebble">
      {hostName}'s {giftlistType} Gift List
    </Typography>
  );

  const GuestCopy = () => (
    <Typography variant="paragraph1" color="pebble">
      {hostName} has put a gift list together with some great choices.
    </Typography>
  );

  const GuestCTA = () => (
    <a
      className="button secondary large"
      href={url}
      title="Go to the giftlist"
      data-qa-id="giftlist__link"
      target="_blank"
      rel="noreferrer"
    >
      Browse {giftlistType} Gift List <ClickOutLineIcon ratio={0.75} />
    </a>
  );

  if (isMobile) {
    return (
      <div className="giftlist-wrap">
        <GuestHeading />
        <div className="giftlist-text-image">
          <GuestCopy />
          <GiftlistImage giftlistType={giftlistType} width="132" />
        </div>

        <GuestCTA />
      </div>
    );
  }

  return (
    <div className="giftlist-wrap">
      <div className="giftlist-guest-desktop-inner">
        <div className="giftlist-left">
          <GuestCopy />
          <GuestCTA />
        </div>
        <GiftlistImage giftlistType={giftlistType} width="132" />
      </div>
    </div>
  );
};
